import { Component, Prop } from 'vue-property-decorator'
import Vue from '@src/vue'
import { CreateElement } from 'vue'
import QrcodeVue from 'qrcode.vue'

import { Icon } from '@src/elements/icon/icon'
import { H6, Overline, Subtitle2 } from '@src/elements/typography/typography'

import { AffectedProduct, ExerciseSupportTicket } from '@src/data/support-ticket'

import './print-ticket-qr.sass'

@Component
export class PrintTicketQR extends Vue {

  @Prop({ required: true })
  private supportTicket: ExerciseSupportTicket

  render (h: CreateElement) {
    return <div class='support-ticket-to-print'>
      <Icon name={'logo/logo-type'} class='logo' />
      <H6>{this.$t('SUPPORT_PAGE.SUPPORT_TICKET.PRINT.TITLE')}</H6>
      <Subtitle2>
        <ol>
          <li>{this.$t('SUPPORT_PAGE.SUPPORT_TICKET.PRINT.1')} <span>{window.location.href}</span></li>
          <li>{this.$t('SUPPORT_PAGE.SUPPORT_TICKET.PRINT.2')}
            {this.supportTicket.problemType === AffectedProduct.STATION_SOFTWARE ? this.$t('SUPPORT_PAGE.SUPPORT_TICKET.PRINT.2_2D') : this.$t('SUPPORT_PAGE.SUPPORT_TICKET.PRINT.2_3D')}
          </li>
          <li>{this.$t('SUPPORT_PAGE.SUPPORT_TICKET.PRINT.3')}</li>
          <li>{this.$t('SUPPORT_PAGE.SUPPORT_TICKET.PRINT.4.1')}<span>{window.location.href}</span>{this.$t('SUPPORT_PAGE.SUPPORT_TICKET.PRINT.4.2')}</li>
          <li>{this.$t('SUPPORT_PAGE.SUPPORT_TICKET.PRINT.5')}</li>
        </ol>
        <div class='contact-details'>{this.$t('SUPPORT_PAGE.SUPPORT_TICKET.PRINT.CONTACT')}
        </div>
      </Subtitle2>
      {this.supportTicket.problemType === AffectedProduct.STATION_SOFTWARE ? <QrcodeVue value={`record_${this.supportTicket.id}`} size={200} class='generated-qr-code' /> :
        <QrcodeVue value='pixSupport' size={200} class='generated-qr-code' />}
      <Overline class='qr-code-caption'>{this.$t('SUPPORT_PAGE.SUPPORT_TICKET.PRINT.QR_CAPTION')}</Overline>
    </div>
  }
}
